import { useQuery } from "@tanstack/react-query";
import { postDefaultArray } from "@api/dummy";
import { QUERY_KEYS } from "@common/queryKeys";

// 검색어 불러오기
const fetchSearchTags = async () => {
  const body = {
    modes: "AllSearchTag",
  };
  const res = await postDefaultArray(body);

  if (res?.Data?.Data) {
    return res.Data.Data;
  }

  throw new Error("검색어 데이터를 불러오지 못했습니다.");
};

export const useSearchTagQuery = () => {
  return useQuery({
    queryKey: QUERY_KEYS.DUMMY.SEARCH,
    queryFn: fetchSearchTags,
    enabled: false, //수동 호출
    staleTime: 1000 * 60 * 30,
  });
};
